import { render, staticRenderFns } from "./competition-list.vue?vue&type=template&id=43f00ba9&scoped=true"
import script from "./competition-list.vue?vue&type=script&lang=js"
export * from "./competition-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f00ba9",
  null
  
)

export default component.exports